import React from 'react'
import PropTypes from "prop-types";

const spanStyle = {
	fontWeight: 'bold'
};

function buildReasonLabel(featureName) {
	return `Why this ${featureName}?`;
}

export const ReasoningLabel = (props) => {
  return (
		<span style={spanStyle}>
			{buildReasonLabel(props.featureName)}
		</span>
	);
};

ReasoningLabel.propTypes = {
	featureName: PropTypes.string.isRequired,
}



// WEBPACK FOOTER //
// ./src/react/views/generic/ReasoningLabel.jsx